import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { EventsState } from "../../../../../../../store/types";
import { AllLayoutTypes } from "../../../../../../../types/template-layouts";
import WaitingIndicator from "../../../../../../general-ui/waiting-indicator/waiting-indicator";

interface LayoutSelectorProps {
	selectedType: AllLayoutTypes;
	currentType: string;
	handleSelectLayout: ((selectedType: AllLayoutTypes) => void);
}

const LayoutSelector: React.FC<LayoutSelectorProps> = ({ selectedType, currentType, handleSelectLayout, children }) => {
	const { saving } = useSelector((state: EventsState) => ({
		saving: state.CreateEventReducer.saving,
	}));
	
	const [clicked, setClicked] = useState(false);

	useEffect(() => {
		if (!saving) {
			setClicked(false);
		}
	}, [saving]);

	const handleClick = () => {
		if (isSelected || (saving && clicked)) {return;}
		setClicked(true);
		handleSelectLayout(selectedType);
	};

	const isSelected = selectedType === currentType;
	return (
		<div className={`module-layout-item ${isSelected ? 'selected-module-layout' : ''} ${saving && clicked ? 'saving-module-layout' : ''}`}>
			<button
				className={`no-style ${isSelected || (saving && clicked) ? 'selected-module-layout-button' : ''}`}
				onClick={handleClick}
			>
				<div className="module-layout-selector-content">
					{children}
					{saving && clicked ? (
						<div className="module-layout-selector-content-waiting-indicator">
							<WaitingIndicator />
						</div>
					) : null}
				</div>
			</button>
		</div>
	);
};

export default LayoutSelector;
